var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRightLeft = function SvgIconRightLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.06 18A.75.75 0 1 1 12 16.94l4.19-4.19H6.75a.75.75 0 0 1 0-1.5h9.441l-4.19-4.19A.75.75 0 1 1 13.06 6l6 6z"
  })));
};
export default SvgIconRightLeft;